<template>
    <div class="">

        <!-- Summary -->
        <div class="row">
            <div class="col-md-12">
                <div class="input-group flex-nowrap p-1 border-0 border-start" :class="[light.border]"
                    style="cursor: default;">
                    <div class="btn me-1" :class="[light.text, light.border, light.back]"
                        style="align-items: center; display:flex; width: 25%">
                        <i class="fa-solid text-primary fa-server me-2" style="font-size: 25px;"></i>
                        <div class="w-100 text-start fw-light fs-4">
                            Devices
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Connected devices."
                        style="width: 25%;">
                        <div class="fa-solid text-success fa-circle-check" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{ connected }}
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Disconnected devices."
                        style="width: 25%;">
                        <div class="fa-solid text-danger fa-circle-xmark" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{ disconnected }}
                        </div>
                    </div>
                    <div class="btn" :class="[light.text, light.border, light.back]" title="Total devices."
                        style="width: 25%;">
                        <div class="fa-solid fa-t" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{ total }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tables -->
        <div class="row mt-3">
            <div class="col-md-12">

                <div class="text-start fw-light fs-4 mb-1" :class="[light.text]"
                    style="letter-spacing: 3px;  margin-top: 30px;">
                    <i class="fa-solid fa-circle-xmark text-danger"></i>
                    Disconnected Devices ({{ disconnected }})
                </div>

                <div class="rounded" style="width: 100%;">
                    <div class="table-responsive" :class="[light.border]" style="overflow:auto;">
                        <table class="table table-sm table-hover mb-0">
                            <thead class="table_header">
                                <tr>
                                    <th>no sitio</th>
                                    <th>ip</th>
                                    <th>llave servicio</th>
                                    <th>alias</th>
                                    <!-- <th>client</th> -->
                                    <!-- <th>cloud</th> -->
                                    <th>os</th>
                                    <th>hostname</th>
                                    <th>id cloud</th>
                                    <th>mac</th>
                                    <th>os version</th>
                                    <th>prod type</th>
                                    <th>sitio</th>
                                    <th>status</th>
                                    <!-- <th>lat</th> -->
                                    <!-- <th>long</th> -->
                                    <th>tunnel if</th>
                                    <th>sitio cat</th>
                                    <th>hostname cat</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(ds, index) in sites_down" :key="index" :class="[light.header, light.text]">
                                    <td>{{ ds.no_sitio }}</td>
                                    <td>{{ ds.ip }}</td>
                                    <td>{{ ds.llave_servicio }}</td>
                                    <td>{{ ds.alias }}</td>
                                    <!-- <td>{{ ds.client }}</td> -->
                                    <!-- <td>{{ ds.cloud }}</td> -->
                                    <td>{{ ds.device_os }}</td>
                                    <td>{{ ds.hostname }}</td>
                                    <td>{{ ds.id_cloud }}</td>

                                    <td>{{ ds.mac_addreess }}</td>
                                    <td>{{ ds.os_version }}</td>
                                    <td>{{ ds.product_type }}</td>
                                    <td>{{ ds.sitio }}</td>
                                    <td>
                                        <span class="badge" :class="{
                                            'bg-success': ds.status === 'up',
                                            'bg-danger': ds.status === 'down',
                                            'bg-secondary': !['up', 'down'].includes(ds.status)
                                        }">
                                            {{ ds.status }}
                                        </span>
                                    </td>
                                    <!-- <td>{{ ds.latitud }}</td> -->
                                    <!-- <td>{{ ds.longitud }}</td> -->
                                    <td>{{ ds.tunnel_if }}</td>
                                    <td>{{ ds.sitio_catalogo }}</td>
                                    <td>{{ ds.hostname_catalogo }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="text-start fw-light fs-4 mb-1" :class="[light.text]"
                    style="letter-spacing: 3px;  margin-top: 30px;">
                    <i class="fa-solid fa-circle-check text-success"></i>
                    Connected Devices ({{ connected }})
                </div>

                <div class="rounded" style="width: 100%;">
                    <div class="table-responsive" :class="[light.border]" style="overflow:auto;">
                        <table class="table table-sm table-hover mb-0">
                            <thead class="table_header">
                                <tr>
                                    <th>no sitio</th>
                                    <th>ip</th>
                                    <th>llave servicio</th>
                                    <th>alias</th>
                                    <!-- <th>client</th> -->
                                    <!-- <th>cloud</th> -->
                                    <th>os</th>
                                    <th>hostname</th>
                                    <th>id cloud</th>
                                    <th>mac</th>
                                    <th>os version</th>
                                    <th>prod type</th>
                                    <th>sitio</th>
                                    <th>status</th>
                                    <!-- <th>lat</th> -->
                                    <!-- <th>long</th> -->
                                    <th>tunnel if</th>
                                    <th>sitio cat</th>
                                    <th>hostname cat</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(ds, index) in sites_up" :key="index" :class="[light.header, light.text]">
                                    <td>{{ ds.no_sitio }}</td>
                                    <td>{{ ds.ip }}</td>
                                    <td>{{ ds.llave_servicio }}</td>
                                    <td>{{ ds.alias }}</td>
                                    <!-- <td>{{ ds.client }}</td> -->
                                    <!-- <td>{{ ds.cloud }}</td> -->
                                    <td>{{ ds.device_os }}</td>
                                    <td>{{ ds.hostname }}</td>
                                    <td>{{ ds.id_cloud }}</td>

                                    <td>{{ ds.mac_addreess }}</td>
                                    <td>{{ ds.os_version }}</td>
                                    <td>{{ ds.product_type }}</td>
                                    <td>{{ ds.sitio }}</td>
                                    <td>
                                        <span class="badge" :class="{
                                            'bg-success': ds.status === 'up',
                                            'bg-danger': ds.status === 'down',
                                            'bg-secondary': !['up', 'down'].includes(ds.status)
                                        }">
                                            {{ ds.status }}
                                        </span>
                                    </td>
                                    <!-- <td>{{ ds.latitud }}</td> -->
                                    <!-- <td>{{ ds.longitud }}</td> -->
                                    <td>{{ ds.tunnel_if }}</td>
                                    <td>{{ ds.sitio_catalogo }}</td>
                                    <td>{{ ds.hostname_catalogo }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import SiteMap from '@/components/apps-components/integrations/customers/banco_del_bajio/deps/SiteMap.vue'

    import axios from "axios";

    export default {
        name: 'Level1',
        props: {
            site: String,
            light: Object,
            mapkey: String
        },
        components: {
            // SiteMap
        },
        data() {
            return {
                source: "paloalto-level-1",
                loading: false,

                timestamp: null,
                maindata: []
            }
        },
        methods: {
            getMaindata() {
                this.loading = true
                console.log('Getting main data...')
                const params = { source: `${this.source}` }
                const dest = this.site + '/integrations/paloalto/data'
                axios
                    .get(dest, { params })
                    .then(rx => {
                        // Code
                        this.maindata = rx.data.response.data.summary
                        this.timestamp = rx.data.response.timestamp
                        this.loading = false
                        this.stopLoading()
                    })
                    .catch(error => {
                        //this.processErrorMessage(error)
                        this.loading = false
                        this.stopLoading()
                    });
            },
            stopLoading() {
                this.$emit('clear-loading-lv1', this.timestamp);
            }
        },
        computed: {
            sites_up() {
                return this.maindata.filter(
                    element => element.status === "up"
                )
            },
            sites_down() {
                return this.maindata.filter(
                    element => element.status === "down"
                )
            },
            connected() {
                return this.sites_up.length;
            },
            disconnected() {
                return this.sites_down.length;
            },
            total() {
                return this.connected + this.disconnected;
            }

        },
        created: function () {
            // Code
            //this.getMaindata()
        },
        mounted: function () {
            // Code
            this.getMaindata()
        }


    }
</script>

<style scoped>

    .cato-main-color {
        color: rgb(67, 139, 108);
    }

    .back-darker {
        background-color: rgb(49, 49, 49);
    }

    .border-bottom-light-grey {
        border-bottom: solid rgb(32, 32, 32) 1px
    }

    .bg-bar {
        background-color: rgb(241, 175, 61);
    }

    .table {
        font-size: 12px;
        white-space: nowrap;
        text-align: left;
    }

    .table th {
        font-size: 13px;
        font-weight: 500;
    }

    .table td {
        font-size: 9px;
        vertical-align: middle;
    }

    .table-hover tbody tr:hover {
        background-color: #96abc9 !important;
    }

    .table-hover tbody tr:hover td {
        color: #ffffff !important;
    }

    .sticky-top {
        z-index: 10;
    }

    .table_header {
        color: cornflowerblue !important;
    }

</style>